import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SupabaseService } from '../services/supabase.service';

export const authRedirectGuard: CanActivateFn = async () => {
  const supabase = inject(SupabaseService);
  const router = inject(Router);

  const { data, error } = await supabase.getUser();
  const user = data?.user;

  // Si hay sesión activa, redirige a página principal
  if (user) {
    router.navigate(['/inicio']); // Redirige a home o dashboard
    return false;
  }

  return true; // Permitir acceso si NO está logueado
};
